export class ListIngestionPipelinePartitionsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListIngestionPipelinePartitionsFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortIngestionPartitionBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIngestionPipelinePartitionsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
